import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Autocomplete from 'components/Common/Autocomplete';
import { ParishUsersAutocompleteProps } from 'types/autocomplete';
import { AppDispatch, RootState } from 'redux/store';
import { fetchParishUsers } from 'redux/slices/user/parishUsers';
import AutocompleteOption from 'components/Common/autocomplete/AutocompleteOption';
import { UserInfo } from 'types/user';

const ParishUsersAutocomplete = ({ user, setUser, excludeUsers, ...props }: ParishUsersAutocompleteProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { loading = false, records = [] } = useSelector((state: RootState) => state?.parishUsers || {});
    const filteredUsers = excludeUsers?.length ? records.filter((user) => !excludeUsers.includes(user?.id)) : records;

    if (user && typeof user === 'string') {
        user = filteredUsers.find((u) => u.username === user);
    } else if (props.value && typeof props.value === 'string') {
        props.value = filteredUsers.find((u) => u.username === props.value);
    }

    useEffect(() => {
        dispatch(fetchParishUsers());
    }, [dispatch]);

    return (
        <Autocomplete
            loading={loading}
            value={user}
            options={filteredUsers}
            onChange={(_: any, user: UserInfo, ...rest) => {
                const { onChange } = props;
                setUser && setUser(user);
                onChange && onChange(_, user, ...rest);
            }}
            getOptionLabel={(option) => option?.name}
            renderOption={(props: any, option: any) => <AutocompleteOption option={option} props={props} />}
            getOptionKey={(option) => (typeof option === 'object' ? option?.uuid : option)}
            {...props}
        />
    );
};

export default ParishUsersAutocomplete;
